module.exports = __webpack_public_path__ + "static/img/craft-bench_256.19b3f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/craft-bench_256.png
// module id = UFqj
// module chunks = 0